import { FLink } from '@components';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { EmprestimoService } from '../../../../../common/services/emprestimo';
import { CONTRATOS_ABSOLUTE_PATH } from '../../../../../common/utils/paths';

const service = new EmprestimoService();

export const Quitacao = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [datas, setDatas] = useState({
    DataInicial: '',
    DataFinal: '',
  });

  useEffect(() => {
    service.obterDatasQuitação().then((res) => {
      setDatas(res);
    });
  }, []);

  return (
    <div className="card">
      <div className="card-body">
        <FLink
          className="justify-content-start mb-32"
          iconLeft="icon-arrow_back"
          onClick={() => navigate(CONTRATOS_ABSOLUTE_PATH)}
        >
          voltar
        </FLink>
        <h3 className="ts-20 fw-bold text-black mb-3">
          Quitação do contrato: {id}
        </h3>

        <p>
          Neste mês, os boletos de quitação devem ser solicitados entre os
          {datas.DataInicial} até {datas.DataFinal}. Gentileza solicitar o
          boleto à Forluz através do telefone 0800.090.9090 ou{' '}
          <a
            className="link d-inline fs-6 text-orange"
            target="_blank"
            href="https://forluz.neoassist.com/?th=tag_vforluzfixa&openEmail=true&mainCategory=emprestimo&subCategory=pagamentos&subCategory2=521056"
            rel="noreferrer"
          >
            Fale Conosco.
          </a>
          Após esse prazo, para reduzir a incidência de juros e correção,
          sugerimos o pagamento na modalidade Antecipação em valor próximo ao do
          saldo devedor. No início do próximo mês solicite à Forluz o envio de
          boleto para quitação do resíduo.
        </p>
      </div>
    </div>
  );
};
